import React from 'react';
import { Message } from 'ui';

function InvitationExpired() {
  return (
    <div className="my-6">
      <Message warning>{gettext('Your invitation has expired.')}</Message>
    </div>
  );
}

export default InvitationExpired;
